import 'font-awesome/css/font-awesome.min.css';
import PropTypes from 'prop-types';
import React from 'react';

import GoogleMap from '../../../../components/GoogleMap/GoogleMap';
import { Group, H3, Paragraph } from '../../../../components/Text/Text';

function DetailBodyLocation(props) {
  const locObj = getLocation(props.location);

  return props.location ? (
    <Group>
      <H3>Location</H3>
      <Paragraph>{locObj.value}</Paragraph>
      <Paragraph>{locObj.address}</Paragraph>
      {getMap(locObj.gmapLocation)}
    </Group>
  ) : null;
}

function getMap(gmapLocation) {
  return gmapLocation ? (
    <GoogleMap
      queryString={gmapLocation}
    />
  ) : null;
}

function getQueryString(loc) {
  return matchQueryStringIfFound(matchHrefIfFound(loc));
}

function matchHrefIfFound(loc) {
  const href = loc.match(new RegExp('href="(.*?)(?=")'));
  return href ? href.pop() : loc;
}

function matchQueryStringIfFound(loc) {
  const qs = loc.match(new RegExp('q\=(.*)'));
  return qs ? qs.pop() : loc;
}

function getLatLngIfFound(loc) {
  const latLng = loc.match(new RegExp('(\\-?\\d+(\\.\\d+)?),\\s*(\\-?\\d+(\\.\\d+)?)'), 'g');
  return latLng ? latLng.shift() : loc;
}

function getLocation(loc) {
  const queryString = getQueryString(loc);
  const address = queryString
    .replace(/%2c/g, ', ')
    .replace(/%20/g, ' ')
    .replace(/\+/g, ' ');
  const value = getHyperlinkValue(loc);
  return {
    address,
    value,
    gmapLocation: getLatLngIfFound(queryString),
  }
}

function getHyperlinkValue(loc) {
  const value = loc.match(
    new RegExp('\<a.*\>(.*)(?=\<\/a)')
  );
  return value ? value.pop().replace('<br />', ' ') : '';
}

DetailBodyLocation.propTypes = {
  location: PropTypes.string,
};

DetailBodyLocation.defaultProps = {
  location: '',
};

export default DetailBodyLocation;



// WEBPACK FOOTER //
// ./src/views/Detail/DetailBody/DetailBodyLocation/DetailBodyLocation.js